export default __webpack_public_path__ + "static/media/hht1_direction_minisitcom_03.7fd04aee.jpg";